import { darken, makeStyles } from '@material-ui/core'

import { lang } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 1fr 0.5fr',
    gap: 5,
    alignItems: 'center',
    paddingLeft: 12,
    color: 'grey',
    marginTop: 20,
    borderRadius: 12,
    marginBottom: 4,
    backgroundColor:
      theme.palette.type === 'dark'
        ? darken(theme.palette.background.default, 0.3)
        : theme.palette.grey[300]
  },
  text: {
    color: theme.palette.grey[800],
    fontSize: lang === 'en' ? '16px' : '15px'
  },
  icon: {
    textAlign: 'right'
  },
  textWithCheckBox: {
    display: 'flex',
    alignItems: 'center'
  },
  checkBoxPadding: {
    padding: '9px 9px 9px 0px'
  }
}))
export default useStyles
